import type { ResultOf } from '@horof/shared';
import { graphql } from './gql';

/** The committee's reports on the desk (docs/changes/45). */

export const MonthlyReportDocument = graphql(`
  query DeskMonthlyReport {
    monthlyReport(first: 36) {
      nodes {
        month
        billsCount
        consumption
        billedTotal
        paymentsTotal
      }
    }
  }
`);
export type MonthRow = NonNullable<
  NonNullable<
    ResultOf<typeof MonthlyReportDocument>['monthlyReport']
  >['nodes'][number]
>;

export const ArrearsDocument = graphql(`
  query DeskArrears {
    arrearsList {
      nodes {
        memberId
        fullName
        amountDue
        billsCount
        oldestBillMonth
        daysOverdue
        publiclyListed
        phoneStatus
        notifyChannel
        noticeLink
      }
    }
  }
`);
export type ArrearRow = NonNullable<
  NonNullable<ResultOf<typeof ArrearsDocument>['arrearsList']>['nodes'][number]
>;

export const RemindersDueDocument = graphql(`
  query DeskRemindersDue {
    remindersDue {
      nodes {
        memberId
        fullName
        kind
        amountDue
        billsCount
        oldestBillMonth
        daysOverdue
        lastRemindedAt
        remindersSent
        notifyChannel
        whatsappUrl
        whatsappMessage
        smsUrl
        smsMessage
        noticeLink
      }
    }
  }
`);
export type ReminderRow = NonNullable<
  NonNullable<
    ResultOf<typeof RemindersDueDocument>['remindersDue']
  >['nodes'][number]
>;

export const RecordReminderDocument = graphql(`
  mutation DeskRecordReminder(
    $memberId: UUID!
    $channel: NotifyChannel!
    $message: String
  ) {
    appRecordReminder(
      input: { memberId: $memberId, channel: $channel, message: $message }
    ) {
      result {
        id
      }
    }
  }
`);

export const AnnualReportLinkDocument = graphql(`
  query DeskAnnualReportLink($year: Int!) {
    annualReportLink(year: $year)
  }
`);
